import { useActions } from 'react-redux-actions-hook'
import { useSelector } from 'react-redux'

import { clearError } from '@/checkout-instore-legacy/order/actions'
import {
  orderLoadingSelector,
  orderErrorSelector,
} from '@/checkout-instore-legacy/order/selectors'

export const useOrderLoading = () => {
  return useSelector(orderLoadingSelector)
}

export const useOrderError = () => {
  return useSelector(orderErrorSelector)
}

export const useOrderErrorActions = () => {
  const actions = useActions({ clearError }, [])

  return {
    ...actions,
  }
}
